import { render, staticRenderFns } from "./productJFQZdetail.vue?vue&type=template&id=11a3964a&scoped=true"
import script from "./productJFQZdetail.vue?vue&type=script&lang=js"
export * from "./productJFQZdetail.vue?vue&type=script&lang=js"
import style0 from "./productJFQZdetail.vue?vue&type=style&index=0&id=11a3964a&prod&lang=css"
import style1 from "./productJFQZdetail.vue?vue&type=style&index=1&id=11a3964a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a3964a",
  null
  
)

export default component.exports